
export const qualityMixin = {  
  data() {
      return {   
          columns: [                
              
          ],
          config: {
              card_mode: false,
              show_refresh_button: false,
              show_reset_button: false,
              per_page: 10,
              server_mode: true, // by default false
              per_page_options: [10, 25, 50],
              global_search: {
                  visibility: false
              },
              preservePageOnDataChange: false
          },
          classes: {},          
          qualitySearchObj : {
                rows:[] , 
                totalCount :0 ,
                filter : {}
          },
          qualityDetailRow: {},
          InitFinished : false,
          deliverySearchResult : [],
          memberList : [] //所有符合採購的廠商
      }
  },
  methods: {
    i18n (keyStr){
      return this.$t(keyStr);
    },
    goBack (){
        this.$router.go(-1);
    },
    doQualitySearch (qualityQueryParam , isEvent){ 
        const self =this;
        const param = qualityQueryParam;        
        let url;
        if(this.searchType === 'quality'){
          url = `${this.$apiUrl_quality}/SearchqualityPageAsync`
        }else if(this.searchType === 'Changequality'){
          url = `${this.$apiUrl_quality}/SearchChangequalityPageAsync`
        }        
        if(isEvent){
            // this.qualitySearchObj.totalCount= 0;
            // this.qualitySearchObj.rows=[];
        }
        this.updateLoading(true);
        this.axios.post(url, param).then((response) => {
            const {status , statusMessage} = response.data;
            this.updateLoading(false);
            if(status){
                this.$alert(statusMessage,'警告',{type: 'warning'});
            }else{
                //--成功          
                const respObj = response.data;
                respObj.filter = param;
                const rows = respObj.rows;
                rows.forEach(r => {
                    //aedat 訂單日期
                    let aedat = r.aedat;
                    r.aedat = self.fixDate(aedat);
                    let isView = self.fixIsView(r.isView);//看過否
                    r.isViewTxt = isView;
                    let confirmTime = self.fixConfirmTime(r.confirmTime);//廠商確認
                    r.confirmTimeTxt = confirmTime
                });
                this.qualitySearchObj = respObj;   
                this.setCacheQueryParam(this.searchType + '_QueryParam' , respObj.filter);
            }                    
        })             
    },
    fixDate(v){
        if(v && v.length >10){
            let newV= v.substring(0,10);
            return newV.replaceAll('-', '/');            
        }
        return v;
    },    
    fixIsView(v){
        if(v === true){
            return 'Y'
        }else{
            return 'N'
        }
    },
    fixConfirmTime(v){
        if(v){
            return '已確認'
        }else{
            return '未確認'
        }
    },
    fixDateTime(v){
        if(v && v.length >16){
            let newV= v.substring(0,16);
            newV =newV.replaceAll('-', '/');
            return newV.replaceAll('T', ' ');
        }
        return v;
    },
    paginationInfoTwText(props){            
        const {filter ,totalCount} = this.qualitySearchObj;
        let startRecNo = 0;
        let endRecNo = 0;
        if(totalCount && totalCount > 0 && filter && filter.pageSize && filter.pageIndex){
            startRecNo = 1 + (filter.pageIndex - 1 ) * filter.pageSize;
            endRecNo = startRecNo + filter.pageSize -1;
            if(endRecNo > totalCount){
                endRecNo = totalCount ;
            }
            return `第 ${startRecNo}筆 ~ 第 ${endRecNo}筆資料列(共${props.originalRowsLength}筆)`;
        }else{
            return '無任何資料列';
        }            
    },        
    onChangeQuery(queryParams) {                
        if(!this.InitFinished){
            this.InitFinished=true;
            return; //初始化未完成
        } 
        let search =  {};
        ({factoryId : search.factoryId, vendorId : search.vendorId,qualityDateBegin : search.qualityDateBegin,qualityDateEnd : search.qualityDateEnd,qualityNoBegin : search.qualityNoBegin,qualityNoEnd : search.qualityNoEnd,isViewed : search.isViewed,isConfirm : search.isConfirm } = this.qualitySearchObj.filter);            
        search.pageSize=queryParams.per_page;
        search.pageIndex=queryParams.page;                 
        this.doqualitySearch(search);            
    },
    initMemberQMList(){        
        this.$store.dispatch('getMemberQMList',{}).then((data) => {            
            this.memberList = data;
        });  
    },
    memberListFilter (filterFactoryId){
        const list = [];        
        if(this.memberList){
            //const filterFactoryId= this.qualityQueryParam.factoryId;
            this.memberList.forEach(e => {
                let add=true;
                if(filterFactoryId){
                    if(e.vendorId.startsWith(filterFactoryId)){
                        add=true;
                    }else{
                        add=false;
                    }
                }
                if(add){
                    //list.push({id: e.vendorId , text: e.vendorName});
                    const labelTxt = e.vendorId + ' - ' + e.vendorAbbreviation;
                    list.push({id: e.vendorId , text: labelTxt});
                }
            });
        }
        return list;
    }
  },
  computed : {      
      isAdmin (){           
          return this.$isAdmin;
      },
      isQMmanager (){ //品質管理者        
        const user = this.$userInfo;
        if(user && (user.roleId === '品質管理者' || user.roleId === 'MIS資訊')){
            return true;
        }
        return false;
      },
      disableFactory (){
        if(this.isMember){
            return true;
        }
        return false;
      },
      userFactoryId (){         
        if(this.isMember){
            return this.$userInfo.userFactory;
        }
        return '';
      },
      userCustomerName (){         
        if(this.isMember){            
            return this.$userInfo.companyName;
        }
        return '';
      },
      disableCusName_input (){
        if(this.isMember){            
            return true;
        }
        return false;
      }
  },
  mounted() {
    //this.InitFinished =true;
  }
}